// Account Statement Model
import funcs from "tools/functions";
import { layout as statementReport } from "./statementReportModel";
import { layout as cashUpReport } from "./cashUpReportModel";
import proxy from "api/proxy";

const stateColors = {
  draft: "amber",
  validated: "lime",
  posted: "blue",
};

async function getActiveOperationCenter() {
  const { data } = await proxy.search(
    "ir.module",
    [
      ["name", "=", "company_operation"],
      ["state", "=", "activated"],
    ],
    ["id"],
  );
  let activeOperationCenter = false;
  if (data?.length > 0) {
    activeOperationCenter = true;
  }
  return { operationCenter: activeOperationCenter };
}

const STATES = [
  { id: "", name: "" },
  { id: "draft", name: "Abierto" },
  { id: "validated", name: "Validado" },
  { id: "posted", name: "Contabilizado" },
];

function getDomain() {
  const terminal = funcs.getCookie();
  const res = [
    ["state", "=", "draft"],
    ["sale_device.code", "=", terminal.device_code],
  ];
  return res;
}

function getFilters() {
  const terminal = funcs.getCookie();
  return {
    draft: [
      ["state", "=", "draft"],
      ["sale_device.code", "=", terminal.device_code],
    ],
  };
}

async function layout() {
  const resActive = await getActiveOperationCenter();
  const ctxView = {
    model: "account.statement",
    table_action: [],
    form_action: [],
    filters: getFilters,
    softDomain: getDomain(),
    activeSearch: true,
    tags: {
      state: stateColors,
    },
    toolbar_table: {
      reports: [
        {
          name: "account_statement_co.advanced",
          label: "account_statement.advanced.report",
          description: "account_statement.advanced.description",
          layout: statementReport(resActive),
        },
        {
          name: "account_statement_co.cash_up",
          label: "account_statement.cash_up.report",
          description: "account_statement.cash_up.description",
          layout: cashUpReport(resActive),
        },
      ],
    },
    fields: {
      name: { type: "char", readOnly: true },
      state: {
        type: "selection",
        readOnly: true,
        tags: stateColors,
        options: STATES,
      },
      turn: { type: "char", readOnly: true },
      date: { type: "date", readOnly: true },
      create_uid: {
        type: "many2one",
        model: "ir.user",
        readOnly: true,
        attrs: ["name"],
      },
      journal: {
        type: "many2one",
        model: "account.journal",
        readonly: true,
        attrs: ["kind"],
      },
      company: {
        type: "many2one",
        model: "company.company",
      },
      sale_device: {
        type: "many2one",
        model: "sale.device",
      },
      end_balance: {
        type: "numeric",
        readonly: true,
      },
      start_balance: {
        type: "numeric",
        readonly: false,
      },
    },
    list: [
      { name: "date", width: "20%" },
      { name: "name", width: "40%" },
      { name: "journal", width: "10%" },
      { name: "create_uid", width: "10%" },
      { name: "sale_device", width: "10%" },
      { name: "end_balance", width: "20%" },
      { name: "turn" },
      { name: "state", width: "10%" },
    ],
    form: [
      { name: "name" },
      { name: "journal" },
      { name: "sale_device" },
      { name: "end_balance" },
      { name: "state" },
    ],
  };
  return ctxView;
}

export { layout };
